import type { NotificationType } from '@dreamstack/feature-components/src/notification/NotificationContext'
import type { SnackbarCloseReason } from '@mui/material'
import { Snackbar } from '@mui/material'
import Alert from '@mui/material/Alert'
import type { FunctionComponent } from 'react'
import React from 'react'

export type SimpleNotificationProps = {
  text: string
  type: NotificationType
  duration?: number
}

export const SimpleNotification: FunctionComponent<SimpleNotificationProps> = ({
  text,
  type,
  duration = 6000,
}) => {
  const [open, setOpen] = React.useState(true)

  const close = () => setOpen(false)
  const handleSnackbarClose = (
    event: Event | React.SyntheticEvent,
    reason: SnackbarCloseReason
  ) => {
    if (reason === 'clickaway') {
      return
    }
    close()
  }

  const handleAlertClose = () => {
    close()
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={open}
      autoHideDuration={duration}
      onClose={handleSnackbarClose}
    >
      <Alert severity={type} onClose={handleAlertClose}>
        {text}
      </Alert>
    </Snackbar>
  )
}
